import { AppExportRules } from "./AppExportRules";

/** Scheduling port; the owning call retains its request and cancellation policy. */
export interface IAssistRetryPoster {
    Later?(Ms: number, Then: () => void): void;
}

/** Product-local quiet retry state shared by ask, keep and forget calls.
 * DOCUMENTED EXCEPTION: caller-owned orchestration. ERROR-SUPPRESSED-JUSTIFIED:
 * timer/hook exceptions propagate to each caller's original reporting boundary;
 * the caller checks its gate, eligibility and optional timer before scheduling.
 */
export class AppAssistRetry {
    public static readonly MaxAgain: number = AppExportRules.MaxAgain;
    private Tries: number = 0;
    private Ended: boolean = false;

    public IsEnded = (): boolean => { return this.Ended; };
    public End = (): void => { this.Ended = true; };

    public WaitFor = (Answer: { Ok: boolean; RetrySec: number }): number => {
        return AppExportRules.AgainAfterMs(Answer, this.Tries, AppAssistRetry.MaxAgain);
    };

    /** Increment before the owner hook and timer, matching the original throwing-operation order. */
    public Schedule = (Wait: number, Poster: IAssistRetryPoster, Again: () => void,
                       Before: (() => void) | null = null): void => {
        this.Tries = this.Tries + 1;
        if (Before !== null) { Before(); }
        Poster.Later!(Wait, Again);
    };
}
